import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom'; // ← Shto këtë
import { Link } from 'react-router-dom';
import ProductCard from '../components/customer/ProductCard';
import API_URL from '../config';
import { 
  FaCouch, 
  FaBed, 
  FaUtensils, 
  FaChair, 
  FaLightbulb,
  FaStar,
  FaArrowRight 
} from 'react-icons/fa';
import '../styles/global.css';

export default function Home() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  useEffect(() => {
    // Lexo parametrin e kërkimit nga URL
    const params = new URLSearchParams(location.search);
    const search = params.get('search');
    if (search) {
      setSearchQuery(search);
    } else {
      setSearchQuery('');
    }
  }, [location.search]);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const res = await fetch(`${API_URL}/api/products`);
      const data = await res.json();
      setProducts(data);
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false);
    }
  };

  // Filtro produktet sipas kërkimit
  const filteredProducts = searchQuery
    ? products.filter(p => 
        p.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        p.category?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        p.description?.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : products;

  // Produktet e reja (30 ditët e fundit)
  const newProducts = filteredProducts.filter(p => {
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    return new Date(p.createdAt) > thirtyDaysAgo;
  });

  // Kategoritë
  const categories = [
    { name: 'Dhoma e ndejes', icon: <FaCouch />, count: filteredProducts.filter(p => p.category === 'Dhoma e ndejes').length },
    { name: 'Dhoma e gjumit', icon: <FaBed />, count: filteredProducts.filter(p => p.category === 'Dhoma e gjumit').length },
    { name: 'Kuzhina', icon: <FaUtensils />, count: filteredProducts.filter(p => p.category === 'Kuzhina').length },
    { name: 'Zyra', icon: <FaChair />, count: filteredProducts.filter(p => p.category === 'Zyra').length },
    { name: 'Aksesorë', icon: <FaLightbulb />, count: filteredProducts.filter(p => p.category === 'Aksesorë').length },
    { name: 'Produkte speciale', icon: <FaStar />, count: filteredProducts.filter(p => p.category === 'Produkte speciale').length },
	{ name: 'Paradhoma', icon: <FaCouch />, count: products.filter(p => p.category === 'Paradhoma').length },
    { name: 'Komoda per TV', icon: <FaCouch />, count: products.filter(p => p.category === 'Komoda per TV').length },
  ];

  if (loading) return <div className="loading">Duke ngarkuar produktet...</div>;

  return (
    <div className="container">
      {/* Hero Mini */}
      <div className="hero-mini">
        <div>
          <h1>Orendion</h1>
          <p>Mobilje dhe aksesorë për çdo ambient</p>
        </div>
        <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          Shfleto të gjitha
        </button>
      </div>

      {/* Rezultati i kërkimit (nëse ka) */}
      {searchQuery && (
        <div style={{ marginBottom: '20px', padding: '10px', background: '#e8f5e9', borderRadius: '8px' }}>
          <p>
            Rezultatet e kërkimit për: <strong>"{searchQuery}"</strong>
            {filteredProducts.length === 0 && " - Nuk u gjet asnjë produkt"}
          </p>
          <Link to="/" style={{ fontSize: '12px', color: '#27ae60' }}>Pastro kërkimin</Link>
        </div>
      )}

      {/* Layout me dy kolona */}
      <div className="home-layout">
        {/* Sidebar me kategori */}
        <aside className="categories-sidebar">
          <h3 className="categories-title">Kategoritë</h3>
          <ul className="categories-list">
            {categories.map(cat => (
              <li key={cat.name} className="category-item">
                <Link 
                  to={`/kategoria/${encodeURIComponent(cat.name)}`} 
                  className="category-link"
                >
                  <span>{cat.name}</span>
                  <span className="category-count">{cat.count}</span>
                </Link>
              </li>
            ))}
          </ul>
        </aside>

        {/* Përmbajtja kryesore */}
        <main>
          {/* Të gjitha produktet (të filtruara) */}
          <section>
            <h2 className="section-title">
              {searchQuery ? 'Rezultatet e kërkimit' : 'Të gjitha produktet'}
            </h2>
            {filteredProducts.length === 0 ? (
              <p>Nuk ka produkte që përputhen me kërkimin tuaj.</p>
            ) : (
              <div className="products-grid">
                {filteredProducts.map(product => (
                  <ProductCard key={product._id} product={product} />
                ))}
              </div>
            )}
          </section>
        </main>
      </div>
    </div>
  );
}